import React, { useState } from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import EnHeader from './Header';
import EnNavigation from './Navigation';
import EnMainContent from './MainContent';
import { useData } from '../../context/DataContext';

// English Application Content Component
function EnAppContent({ onLanguageChange }) {
  // Get state from data context
  const { 
    conversations, 
    themes, 
    tags, 
    favorites, 
    isLoading, 
    error, 
    toggleFavorite 
  } = useData();

  // Current selected view (timeline or theme)
  const [currentView, setCurrentView] = useState('timeline');
  
  // Current selected conversation
  const [selectedConversation, setSelectedConversation] = useState(null);
  
  // Search query
  const [searchQuery, setSearchQuery] = useState('');
  
  // Filter settings
  const [filters, setFilters] = useState({
    dateRange: null,
    tags: [],
    themes: [],
  });

  // Handle navigation item click
  const handleNavItemClick = (view) => {
    setCurrentView(view);
    setSelectedConversation(null);
  };

  // Handle conversation click
  const handleConversationClick = (conversation) => {
    setSelectedConversation(conversation);
  };

  // Handle search
  const handleSearch = (query, targetView = null) => {
    setSearchQuery(query);
    
    // Switch to target view if specified
    if (targetView) {
      setCurrentView(targetView);
    }
  };

  // Handle filter change
  const handleFilterChange = (newFilters) => {
    setFilters({ ...filters, ...newFilters });
  };

  // Loading display
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  // Error display
  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      {/* Header */}
      <EnHeader onSearch={handleSearch} onLanguageChange={onLanguageChange} />
      
      {/* Main Content Area */}
      <Box sx={{ display: 'flex', flexGrow: 1, overflow: 'hidden' }}>
        {/* Navigation */}
        <EnNavigation 
          currentView={currentView} 
          onNavItemClick={handleNavItemClick}
        />
        
        {/* Main Content */}
        <EnMainContent 
          currentView={currentView}
          conversations={conversations}
          themes={themes}
          tags={tags}
          favorites={favorites}
          selectedConversation={selectedConversation}
          onConversationClick={handleConversationClick}
          searchQuery={searchQuery}
          filters={filters}
          onFilterChange={handleFilterChange}
          onToggleFavorite={toggleFavorite}
          onSearch={handleSearch}
          onNavItemClick={handleNavItemClick}
        />
      </Box>
    </Box>
  );
}

export default EnAppContent; 